import React from 'react';
import Navigation from './Navigation';
import LogOutCard from './LogOutCard';

function DrawerContent({ menuItems }) {
  return (
    <div style={{ ...styles.content, scrollbarWidth: 'thin', scrollbarColor: 'rgba(255,255,255,0.4) transparent' }}>
      <Navigation items={menuItems} />
      <LogOutCard />
    </div>
  );
}

const styles = {
  content: {
    flex: 1,
    overflowY: 'auto',
    padding: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
};

export default DrawerContent;
